import React from "react";
import FileManager from "../../../fileManager";
import { Grid, Box } from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import PanoramaIcon from "@material-ui/icons/Panorama";
import FolderIcon from "@material-ui/icons/Folder";
import { withStyles } from "@material-ui/styles";
import DetailItem from "../../../fileManager/fileDetail";
import { styles } from "../../../fileManager/styles";
import TableHeader from "../../../fileManager/tableHeader";
import TableFile from "../../../fileManager/tableFile";
import TableFolder from "../../../fileManager/tableFolder";
import FileAction from "../../../fileManager/fileAction";
import { connect } from "react-redux";
import ConfirmDialog from "../../../fileManager/dialog";
import Loading from "../../../loading";
import Header from "../../../../partials/header";
import { translate } from "react-i18next";

class Album extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      isOpenModal: false,
      selectedFolder: {
        key: "",
        size: 0,
        download: null,
        createdAt: new Date(),
        url: null,
        relativeKey: "",
      },
    };
    this.createNewFolder = this.createNewFolder.bind(this);
    this.createNewFile = this.createNewFile.bind(this);
    this.checkDuplicatedName = this.checkDuplicatedName.bind(this);
    this.remove = this.remove.bind(this);
    this.rename = this.rename.bind(this);
  }
  async componentDidMount() {
    this.loading.startLoading();
    await this.props.getAlbumForRole();
    this.loading.stopLoading();
  }

  selectFile(file) {
    this.setState({ selectedFile: file });
  }
  async createNewFolder(key) {
    const { serviceCode } = this.props;
    this.props.addNewFolder({
      key,
      size: 0,
      download: "",
      createdAt: new Date(),
      url: "",
    });
    this.loading.startLoading();
    await this.props.uploadFolder({
      serviceCode,
      path: key,
    });
    this.loading.stopLoading();
  }
  handleGlobalClick() {
    this.setState({
      selectedFolder: null,
    });
  }
  async createNewFile(files, prefix) {
    const file = files[0];
    const { serviceCode } = this.props;
    this.props.addNewFiles({
      key: prefix + file.name,
      size: file.size,
      download: "",
      createdAt: new Date(),
      url: "",
    });
    this.loading.startLoading();
    await this.props.uploadFile({
      file: file,
      prefix,
      code: serviceCode,
    });
    await this.props.getAlbumForRole();
    this.loading.stopLoading();
  }
  async remove(file) {
    this.loading.startLoading();
    this.setState({ selectedFile: null });
    await this.props.remove({
      code: file.code,
      imageUrl: file.imageUrl,
      thumbnailUrl: file.thumbnailUrl,
    });
    await this.props.getAlbumForRole();
    this.loading.stopLoading();
  }
  async rename({ code, name }) {
    this.loading.startLoading();
    await this.props.rename({
      code,
      name,
    });
    this.loading.stopLoading();
  }
  checkDuplicatedName({ name, path }) {
    const { list } = this.props;
    const result = list.some((item) => {
      return item.key === path + name;
    });
    return !result;
  }
  render() {
    const { list, t, dialogView, getFileUrl = () => {} } = this.props;
    const { selectedFile, selectedFolder, isOpenModal } = this.state;
    const col = selectedFile ? 8 : 12;
    return (
      <Box component="div">
        <Grid container spacing={2}>
          <Grid item lg={col} md={col} sm="12">
            <FileManager
              files={list}
              title={t("image_list")}
              canFilter={false}
              icons={{
                FolderOpen: <FolderOpenIcon />,
                Folder: <FolderIcon />,
                File: <PanoramaIcon />,
                Delete: <DeleteOutlineOutlinedIcon />,
              }}
              headerRenderer={TableHeader}
              actionRenderer={(props) => {
                if (dialogView) {
                  return "";
                }
                return (
                  <Grid container justify="space-between" alignItems="center">
                    <Header
                      session={t("sidebar_manage")}
                      title={t("service_ownerspa_service_album")}
                      button={null}
                      actionButton={() => {}}
                    />
                    <FileAction
                      {...props}
                      onCreateFile={(files, prefix) => {
                        this.createNewFile(files, prefix);
                      }}
                      allowCreateFile={true}
                      allowCreateFolder={false}
                    />
                  </Grid>
                );
              }}
              fileRenderer={(props) => {
                return (
                  <TableFile
                    {...props}
                    rename={this.rename}
                    refresh={() => {
                      return this.props.getAlbumForRole();
                    }}
                    checkDuplicatedName={this.checkDuplicatedName}
                    getFileUrl={(url) => {
                      if (dialogView) {
                        return getFileUrl(url);
                      }
                      return null;
                    }}
                  />
                );
              }}
              folderRenderer={(props) => {
                return <TableFolder {...props} />;
              }}
              detailRenderer={DetailItem}
              detailRendererProps={{
                file: selectedFile,
                folder: selectedFolder,
                isDisplay: false,
              }}
              onCreateFolder={(key) => {
                this.createNewFolder(key);
              }}
              onCreateFiles={(files, prefix) => {
                this.createNewFile(files, prefix);
              }}
              onSelectFile={(file) => {
                this.setState({ selectedFile: file });
              }}
              onSelectFolder={(folder) => {
                this.setState({
                  selectedFolder: folder,
                });
              }}
              onDeleteFile={(file) => {
                this.setState({
                  selectedFile: file,
                  isOpenModal: !isOpenModal,
                });
              }}
            />
          </Grid>
          {selectedFile && (
            <Grid
              className="file-detail-container"
              item
              lg={12 - col}
              md={12 - col}
              sm="12"
            >
              <DetailItem
                file={selectedFile}
                folder={selectedFolder}
                close={() => {
                  this.setState({ selectedFile: null });
                }}
                isDisplay={true}
              />
            </Grid>
          )}
        </Grid>
        <Loading
          onRef={(id) => {
            this.loading = id;
          }}
        />
        <ConfirmDialog
          open={isOpenModal}
          handleClose={() => {
            this.setState({ isOpenModal: !isOpenModal });
          }}
          file={selectedFile}
          confirm={() => {
            this.remove(selectedFile);
          }}
        />
      </Box>
    );
  }
}
const mapState = (state) => ({
  list: state.album.list,
  serviceCode: state.user.user.roleId.serviceCode,
});
const mapDispatch = (dispatch) => ({
  getAlbumForRole: dispatch.album.getAlbumForRole,
  addNewFolder: dispatch.album.addNewFolder,
  addNewFiles: dispatch.album.addNewFiles,
  uploadFile: dispatch.album.uploadFile,
  uploadFolder: dispatch.album.uploadFolder,
  rename: dispatch.album.rename,
  remove: dispatch.album.remove,
});
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(Album)));
